export const supporters = [
  {
    name: "Nemzeti Kulturális Alap",
    address: "1085 Budapest, Gyulai Pál utca 13.",
    email: "titkarsag@nktk.hu",
    website: "https://www.nka.hu",
    logo: "/supporters/nka.png"
  },
  {
    name: "Siófok Város Polgármesteri Hivatala",
    address: "8600 Siófok, Fő tér 1.",
    website: "https://www.siofok.hu",
    logo: "/supporters/siofok_cimer.png",
  },
  {
    name: "Kálmán Imre Művelődési Központ",
    address: "8600 Siófok, Fő tér 2.",
    phone: "+36 84 311 855",
    email: "info@kulturkozpont-siofok.hu",
    logo: "/supporters/kalman.png",
    website: "https://muvelodesikozpont-siofok.hu/",
  },
  {
    name: "Nemzeti Együttműködési Alap",
    address: "1016 Budapest, Gellérthegy u. 30-32.",
    phone: "+36 1 896 0620",
    email: "nea@bgazrt.hu",
    logo: "/supporters/nea.png",
  },
  {
    name: "Csoóri Sándor Alap",
    address: "1392 Budapest, Pf. 298.",
    phone: "06-1-550-2790",
    email: "cssp@nktk.hu",
    logo: "/supporters/csoori.png"
  },
  {
    name: "Városi Civil Alap",
    address: "1016 Budapest, Gellérthegy u. 30-32.",
    phone: "+36 1 795 9601",
    email: "vca@bgazrt.hu",
    logo: "/supporters/vca.png"
  },
  {
    name: "Bethlen Gábor Alap",
    address: "1016 Budapest, Gellérthegy utca 30-32.",
    website: "https://bgazrt.hu",
    logo: "supporters/bga.png"
  },
    {
    name: "Miniszterelnökség",
    address: "1055 Budapest, Kossuth Lajos tér 2-4.",
    website: "https://kormany.hu/miniszterelnokseg",
    phone: "+36-1-795-5000",
    email: "erkeztetok@me.gov.hu",
    logo: "supporters/miniszter.png"
  },
  {
    name: "Agrárminisztérium",
    address: "1055 Budapest, Kossuth Lajos tér 11.",
    website: "https://kormany.hu/kormanyzat/agrarminiszterium",
    phone: "+36-1-795-2000",
    email: "info@am.gov.hu",
    logo: "supporters/agrarminiszterium.jpg"
  },
  {
    name: "Hungarikum Bizottság",
    address: "1392 Budapest, Pf.: 279",
    website: "https://www.hungarikum.kormany.hu",
    email: "hungarikum@am.gov.hu",
    logo: "supporters/hungarikum.jpg"
  },
  {
    name: "Expodom",
    website: "https://www.expodom.hu/",
    logo: "/supporters/expodom.png"
  },
];
